import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { RoyalCrown } from './RoyalCrown';

const RAYS = Array.from({ length: 16 }, (_, i) => i * 22.5);

/* Cinematic crown forge when all three rituals are done in one day. */
export const DailyCrown = ({ total, onDone }) => {
  useEffect(() => { const t = setTimeout(onDone, 4200); return () => clearTimeout(t); }, [onDone]);
  return (
    <motion.div className="fixed inset-0 z-[310] flex flex-col items-center justify-center text-center px-8" onClick={onDone}
      initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} data-testid="oath-daily-crown"
      style={{ background: 'radial-gradient(circle at 50% 42%, rgba(212,175,55,0.35), #030306 65%), #030306' }}>
      <motion.div className="absolute" style={{ top: '30%' }} animate={{ rotate: 360 }} transition={{ duration: 18, repeat: Infinity, ease: 'linear' }}>
        {RAYS.map((r) => (
          <span key={r} className="absolute left-0 top-0 origin-bottom" style={{ width: 3, height: 180, transform: `translate(-50%, -100%) rotate(${r}deg)`, background: 'linear-gradient(0deg, rgba(255,233,160,0.6), transparent)' }} />
        ))}
      </motion.div>
      <motion.div className="relative" initial={{ y: -300, scale: 0.4, rotate: -30 }} animate={{ y: 0, scale: 1, rotate: 0 }}
        transition={{ type: 'spring', stiffness: 180, damping: 12 }} ><RoyalCrown size={170} /></motion.div>
      <div className="flex gap-4 mt-6">
        {['#D4AF37', '#5BE08A', '#5DD4FF'].map((c, i) => (
          <motion.span key={c} className="w-4 h-4 rotate-45 rounded-[3px]" initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 0.6 + i * 0.15 }}
            style={{ background: c, boxShadow: `0 0 14px ${c}` }} />
        ))}
      </div>
      <motion.p className="font-['Cinzel'] text-3xl mt-6" style={{ color: '#FFE9A0' }} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1 }}>Daily Crown Forged</motion.p>
      <motion.p className="font-['Outfit'] text-sm text-white/65 mt-3" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.4 }}>
        Word sworn. Gratitude fed. Focus locked. Crown number {total} — you are becoming unstoppable.
      </motion.p>
    </motion.div>
  );
};

export default DailyCrown;
